/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Event_Metrics_Seconds_UnitInputs */

const en_event_metrics_seconds_unit = /** @type {(inputs: Event_Metrics_Seconds_UnitInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`sec`)
};

const fr_event_metrics_seconds_unit = /** @type {(inputs: Event_Metrics_Seconds_UnitInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`s`)
};

const de_event_metrics_seconds_unit = /** @type {(inputs: Event_Metrics_Seconds_UnitInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sekunde`)
};

const it_event_metrics_seconds_unit = /** @type {(inputs: Event_Metrics_Seconds_UnitInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`secondo`)
};

const ru_event_metrics_seconds_unit = /** @type {(inputs: Event_Metrics_Seconds_UnitInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`сек`)
};

const es_event_metrics_seconds_unit = /** @type {(inputs: Event_Metrics_Seconds_UnitInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`segundo`)
};

const zh_cn2_event_metrics_seconds_unit = /** @type {(inputs: Event_Metrics_Seconds_UnitInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`秒`)
};

const ja_event_metrics_seconds_unit = /** @type {(inputs: Event_Metrics_Seconds_UnitInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`秒`)
};

const hi_event_metrics_seconds_unit = /** @type {(inputs: Event_Metrics_Seconds_UnitInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`सेकंड`)
};

const pt_pt2_event_metrics_seconds_unit = /** @type {(inputs: Event_Metrics_Seconds_UnitInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`seg`)
};

/**
* | output |
* | --- |
* | "sec" |
*
* @param {Event_Metrics_Seconds_UnitInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const event_metrics_seconds_unit = /** @type {((inputs?: Event_Metrics_Seconds_UnitInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Event_Metrics_Seconds_UnitInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_event_metrics_seconds_unit(inputs)
	if (locale === "de") return de_event_metrics_seconds_unit(inputs)
	if (locale === "it") return it_event_metrics_seconds_unit(inputs)
	if (locale === "ru") return ru_event_metrics_seconds_unit(inputs)
	if (locale === "es") return es_event_metrics_seconds_unit(inputs)
	if (locale === "zh-CN") return zh_cn2_event_metrics_seconds_unit(inputs)
	if (locale === "ja") return ja_event_metrics_seconds_unit(inputs)
	if (locale === "hi") return hi_event_metrics_seconds_unit(inputs)
	if (locale === "pt-PT") return pt_pt2_event_metrics_seconds_unit(inputs)
	return en_event_metrics_seconds_unit(inputs)
});